import type { SupabaseAnonKey } from '@shady-pines/api';
import { ZodUrl } from '@shady-pines/types/src/url';
import { z } from 'zod';

// Client-side accessible configuration
const _publicConfiguration = z.object({
  NEXT_PUBLIC_SUPABASE_URL: ZodUrl,
  NEXT_PUBLIC_SUPABASE_ANON_KEY: z
    .string()
    .min(1)
    .transform<SupabaseAnonKey>((s) => s as SupabaseAnonKey),

  NEXT_PUBLIC_GOOGLE_CLIENT_ID: z.string().min(1),
});

export const publicConfig = _publicConfiguration.parse({
  NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
});
